<template>
  <div class="elr-conent">
    <div class="lefts">
      <el-row :gutter="20">
        <el-col :span="3">
          <div class="grid-content bg-purple">
            <div class="label">
              发票收件人：
              <span class="value">{{ apApply.invoiceRecipient }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple">
            <div class="label">
              收件人详情：
              <el-tooltip class="item" effect="light" placement="top-start">
                <span class="value">{{ apApply.invoiceRecipientDetail }}</span>
                <span class="value" slot="content">{{
                  apApply.invoiceRecipientDetail
                }}</span>
              </el-tooltip>
            </div>
          </div>
        </el-col>

      </el-row>
      <el-row :gutter="20">
        <el-col :span="3">
          <div class="grid-content bg-purple">
            <div class="label">
              快递公司：
              <span class="value">{{ courierCompanyText[apApply.courierCompany] }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">
            <div class="label">
              快递单号：
              <span class="value">{{ apApply.courierNo }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import common from '@/modules/transport/bms/common/common';
const { initSessionData } = common;
export default {
    props: {
        apApply: {
            type: Object
        }
    },
    data() {
        return {
            data: {},
            courierCompanyText: {}
        };
    },
    async created() {
        await initSessionData(['SYS_BMS_EXPRESS_COMPANY']);
        const { SYS_BMS_EXPRESS_COMPANY } = window.sessionStorage;
        this.courierCompanyText = JSON.parse(SYS_BMS_EXPRESS_COMPANY);
    }

};
</script>

<style lang="less">
.elr-conent {
  display: flex;
  .lefts {
    flex: 7;
  }
  .rights {
    flex: 1;
    display: flex;
  }
  .rights-r {
    flex: -1;
    text-align: center;
  }
  .prices {
    margin-top: 6px;
    font-size: 24px;
    color: #ff8800;
  }
  .amount {
    font-size: 14px;
    color: #333;
    margin-top: 10px;
  }
  .prices-m {
    color: #000;
    font-size: 14px;
  }
}
</style>